import { apiClient } from "../config";
async function updatePassword(data: any) {
  const res = await apiClient.put(`/admin/password`, data);
  return res.data;
}

export default updatePassword;
